"use client";

import Image from "next/image";
import React, { useState, useEffect } from "react";
import Manuals from "./Manuals";
import Link from "next/link";
import SizeChanger from "./SizeChanger";

export default function Model(props) {
  const machine = props.data;
  const decks = props.data.decks;
  let types = new Set(decks.map((machine) => machine.type));
  types = Array.from(types); // Convert back to array
  const [deckTypeImage, setDeckTypeImage] = useState(() => {
    const diskDeck = machine.decks.find(
      (deck) => deck.type.data.attributes.type === "Disk"
    );
    return diskDeck
      ? diskDeck.type.data.attributes.image.data.attributes.url
      : "";
  });
  const [selectedDeckDescription, setSelectedDeckDescription] = useState(() => {
    const diskDeck = machine.decks.find(
      (deck) => deck.type.data.attributes.type === "Disk"
    );
    return diskDeck ? diskDeck.type.data.attributes.description : "";
  });
  const [selectedDeckType, setSelectedDeckType] = useState(() => {
    const diskDeck = decks.find(
      (deck) => deck.type.data.attributes.type === "Disk"
    );
    return diskDeck ? "Disk" : "";
  });
  const [selectedDeckImage, setSelectedDeckImage] = useState(() => {
    const diskDeck = decks.find(
      (deck) => deck.type.data.attributes.type === "Disk"
    );
    return diskDeck
      ? diskDeck.image.data.attributes.url
      : machine.main_image.data.attributes.url;
  });
  const [selectedThumbNails, setSelectedThumbNails] = useState(() => {
    const diskDeck = decks.find(
      (deck) =>
        deck.type.data.attributes.type === "Disk" ||
        deck.type.data.attributes.type === "Sweeper"
    );
    return diskDeck ? diskDeck.thumbs.data : null;
  });

  useEffect(() => {
    setSelectedDeckImage(() => {
      const diskDeck = decks.find(
        (deck) => deck.type.data.attributes.type === "Disk"
      );
      return diskDeck
        ? diskDeck.image.data.attributes.url
        : machine.main_image.data.attributes.url;
    });
    setSelectedDeckType(() => {
      const diskDeck = decks.find(
        (deck) => deck.type.data.attributes.type === "Disk"
      );
      return diskDeck ? "Disk" : "";
    });
    setSelectedDeckDescription(() => {
      const diskDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === "Disk"
      );
      return diskDeck ? diskDeck.type.data.attributes.description : "";
    });
    setDeckTypeImage(() => {
      const diskDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === "Disk"
      );
      return diskDeck
        ? diskDeck.type.data.attributes.image.data.attributes.url
        : "";
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  const diskWithSmallestSize =
    decks.length > 1
      ? decks
        .filter((deck) => deck.type.data.attributes.type === "Disk")
        .reduce((prev, current) =>
          parseInt(current.size) < parseInt(prev.size) ? current : prev
        )
      : null;

  const sizeLabel = diskWithSmallestSize
    ? diskWithSmallestSize.size + diskWithSmallestSize.label
    : null;

  const [selectedDeckSize, setSelectedDeckSize] = useState(sizeLabel);

  const handleSelectedDeckSize = (deck) => {
    setSelectedDeckSize(deck.size + deck.label);
    setSelectedDeckImage(deck.image.data?.attributes.url || selectedDeckImage);
  };
  const handleSelectedDeckType = (data) => {
    let deck = data.attributes;
    setSelectedDeckType(data);
    // Find the smallest size with the selected deck type
    const filteredDecks = machine.decks.filter(
      (machineDeck) => machineDeck.type.data.attributes.type === data
    );
    const smallestDeck = filteredDecks.reduce((smallest, current) => {
      const smallestSize = parseInt(smallest.size);
      const currentSize = parseInt(current.size);
      return currentSize < smallestSize ? current : smallest;
    });
    setDeckTypeImage(() => {
      const matchingDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === data
      );
      return matchingDeck
        ? matchingDeck.type.data.attributes.image.data.attributes.url
        : "null";
    });
    setSelectedThumbNails(() => {
      const matchingDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === data
      );
      return matchingDeck ? matchingDeck.thumbs.data : null;
    });
    setSelectedDeckDescription(() => {
      const matchingDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === data
      );
      return matchingDeck
        ? matchingDeck.type.data.attributes.description
        : "null";
    });
    setSelectedDeckSize(smallestDeck.size + smallestDeck.label);
    setSelectedDeckImage(smallestDeck.image.data.attributes.url);
  };

  const uniqueDeckTypes = Array.from(
    new Set(machine.decks.map((item) => item.type.data.id))
  ).map((id) => {
    return machine.decks.find((item) => item.type.data.id === id);
  });


  return (
    <>
      <div className="main-section-wrapper">
        <div className="image-thumb-changer-wrapper">
          <div
            className="thumbs-image-wrapper"
            style={{
              gridTemplateColumns: selectedThumbNails?.length > 0 ? "" : "1fr",
            }}
          >
            <div className="thumbnails-wrapper">
              {selectedThumbNails?.length > 0 &&
                selectedThumbNails.map((image) => (
                  <div
                    className="thumb"
                    key={image.id}
                    onClick={() => setSelectedDeckImage(image.attributes.url)}
                  >
                    <Image
                      src={image.attributes.url}
                      width={100}
                      height={100}
                      alt={`${machine.name} ${machine.style.data.attributes.style} ${selectedDeckType} thumbnail`}
                      priority
                    />
                  </div>
                ))}
            </div>
            <div className="image-wrapper">
              <Image
                src={selectedDeckImage}
                width={500}
                height={500}
                alt={`${machine.name} - ${machine.style.data.attributes.style} ${selectedDeckType}`}
                priority
              />
              <SizeChanger data={props.data} />
            </div>
          </div>
        </div>
      </div>
      <div className="details-section-wrapper">
        <div className="heading-wrapper desktop">
          <div className="title-wrapper">
            <h1 className="title">
              {machine.name} <span>{machine.version} </span> <br />
              <span className="style">
                {machine.style.data.attributes.style}
              </span>
            </h1>
            <Link href="#demo" className="request-demo-btn">
              Request a Demo
            </Link>
          </div>
          <div className="spec-wrapper">
            {machine.spec.map((spec) => (
              <div className="detail" key={spec.id}>
                <h2>{spec.spec_label.slice(0, -1)}</h2>
                <span>{spec.spec_description}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="description-wrapper">
          {machine.new_description.map((description) => (
            <p key={description.id}>{description.paragraph}</p>
          ))}
        </div>
        <div className="deck-selector-wrapper">
          <div className="decks-wrapper">
            <div>
              {uniqueDeckTypes.length > 1 && <h3>Choose a Scrub System</h3>}
              <div className="scrub-systems-wrapper">
                {uniqueDeckTypes.length > 1 &&
                  uniqueDeckTypes.map((item) => (
                    <div key={item.id} className="scrub-system">
                      {/* <p>{item.type.data.attributes.description}</p> */}
                      <button
                        className={
                          selectedDeckType === item.type.data.attributes.type
                            ? "selected"
                            : ""
                        }
                        onClick={() =>
                          handleSelectedDeckType(item.type.data.attributes.type)
                        }
                      >
                        {item.type.data.attributes.type}
                      </button>
                    </div>
                  ))}
              </div>
            </div>

            <div className="scrubdeck-sizes-wrapper">
              {machine.decks.length > 1 && <h3>Choose your size</h3>}
              <div className="deck-sizes">
                {machine.decks.length > 0 &&
                  machine.decks
                    .filter(
                      (deck) =>
                        deck.type.data.attributes.type === selectedDeckType
                    )
                    .map((deck) => (
                      <button
                        className={`deck-size ${deck.size + deck.label === selectedDeckSize
                          ? "selected"
                          : ""
                          }`}
                        key={deck.id}
                        onClick={() => handleSelectedDeckSize(deck)}
                      >
                        <h4>{deck.size + " " + deck.label}</h4>
                      </button>
                    ))}
              </div>
            </div>
          </div>
          {deckTypeImage && (
            <Image
              src={deckTypeImage}
              width={300}
              height={300}
              alt={`${machine.name} - ${machine.style.data.attributes.style} - ${selectedDeckType} scrub system`}
              onClick={() => {
                item &&
                  item?.type?.data?.attributes?.type &&
                  handleSelectedDeckType(item.type.data.attributes.type);
              }}
            />
          )}
        </div>
        <Manuals data={machine} />
      </div>
    </>
  );
}
